import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Overline } from "@/components/Bits";
import { EditorialMarquee } from "@/components/EditorialMarquee";

const SERVICES = [
  { title: "Commodity Trade Advisory", desc: "Strategic guidance on international commodity trade, sourcing, and compliance." },
  { title: "International Business Documentation", desc: "Professional preparation of cross-border business and trade documentation." },
  { title: "Leadership & Executive Coaching", desc: "One-on-one coaching for executives and emerging leaders." },
  { title: "Proposal Development", desc: "Compelling, fundable proposals for grants, partnerships, and ventures." },
  { title: "Contract Development", desc: "Clear, protective agreements built on best practice." },
  { title: "Business Strategy & Planning", desc: "Roadmaps that translate vision into sustainable growth." },
  { title: "Organizational Transformation", desc: "Culture, systems, and leadership change that lasts." },
  { title: "AI Adoption for Organizations", desc: "Practical AI integration strategies for teams and enterprises." },
];

export default function Consulting() {
  return (
    <div data-testid="consulting-page">
      <PageHero
        overline="Business Consulting"
        title={<>Building ethical businesses with <span className="font-accent text-gold-gradient italic">Kingdom excellence.</span></>}
        subtitle="Strategic consulting that combines biblical principles with international best practice — helping organizations grow sustainably and ethically."
      />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 py-24">
        <Reveal className="mb-14"><Overline>Consulting Services</Overline></Reveal>
        <div className="grid gap-px bg-gold-500/15 border border-gold-500/15 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={(i % 2) * 0.06}>
              <div className="group flex items-start gap-6 bg-ink p-9 transition-colors duration-500 hover:bg-ink-paper" data-testid={`consulting-${i}`}>
                <span className="font-serif text-4xl text-gold-500/60 leading-none">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif text-2xl text-white group-hover:text-gold-300 transition-colors">{s.title}</h3>
                  <p className="mt-3 text-sm text-white/60 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-24 grid gap-14 lg:grid-cols-2 lg:items-center">
        <Reveal>
          <div className="corner-frame border border-gold-500/25 p-1">
            <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Consulting" className="aspect-[4/3] w-full object-cover" />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="font-accent italic text-3xl md:text-4xl leading-tight text-white">
            "Excellence and integrity are not competing values — together they build enterprises that
            endure."
          </p>
          <Link to="/contact" className="mt-10 inline-flex items-center gap-2 bg-gold-500 px-8 py-4 text-sm font-semibold text-ink hover:bg-gold-400 active:scale-[0.98] transition-[background,transform] duration-300">
            Book a Consultation <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </section>

      <EditorialMarquee text="STRATEGY · INTEGRITY · GROWTH" />
    </div>
  );
}
